var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"churn-button",on:{"click":_vm.openChurnFlow}},[_c('span',{staticClass:"button-title"},[_vm._v("סגירת חשבון ומחיקת פרטים")]),_vm._v(" "),_c('span',{staticClass:"button-icon fa fa-chevron-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }